import React from 'react';

import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';
import { ASSET_SIZE_TYPES, getAssetSrcFromId } from 'utils/asset';

import s from './index.module.css';

function Document(props) {
  const { block } = props;

  return (
    <div className={s.wrapper}>
      <Text className={s.title} data-block>
        {i18n.t('proposal_content.file.pdf_documents')}
      </Text>

      <div className={s.list}>
        {block?.data?.files?.map((file, i) => (
          <Text key={i}>
            <a
              href={getAssetSrcFromId(file.id, ASSET_SIZE_TYPES.FULL)}
              target="_blank"
              rel="noopener noreferrer"
              className={s.name}
            >
              {file.name}
            </a>
          </Text>
        ))}
      </div>
    </div>
  );
}

export default Document;
